import React, { useState } from "react";
import "./SellerLogin.css";
import logo from "../../assets/logo.png";
import loginbg from "../../assets/sidelogo.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";

export default function SellerLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

    const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // const passwordRegex = /^[1-9]{9}$/;
    const passwordRegex = /^\d{9,15}$/;



  const handleSubmit = async () => {
    let temp = {};

if (!email.trim()) {
  temp.email = "البريد الإلكتروني مطلوب";
} else if (!emailRegex.test(email)) {
  temp.email =
  "من فضلك أدخل بريد إلكتروني صحيح  " 

}

if (!password.trim()) {
  temp.password = "كلمة المرور مطلوبة";
} else if (!passwordRegex.test(password)) {
  temp.password = "كلمة المرور يجب أن تكون من 9 إلى 15 رقم";
}

    setErrors(temp);
    if (Object.keys(temp).length > 0) return; 

try {
  setLoading(true);

  const response = await axios.post(
    BaseUrl + SellerServicesUrl.SellerLogin,
    { email, password: Number(password) }
  );

  console.log("LOGIN DATA:", response.data.data);

  const token = response.data.data.token;   
  const user = response.data.data.user;

  if (user.type !== "saller") {
    setErrors({ general: "هذا الحساب ليس حساب بائع" });
    return;
  }

  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("userType", user.type);
  localStorage.setItem("isLoggedIn", "true");

  window.dispatchEvent(new Event("authChanged"));
  navigate("/seller/sellerhome");

} 
 catch (error) {
  const serverMessage = error.response?.data?.message;

  if (error.response?.status === 401 || serverMessage === "fail") {
    setErrors({
      general: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    });
  } else {
    setErrors({
      general: "حدث خطأ، حاول مرة أخرى لاحقًا",
    });
  }
} 
finally {
  setLoading(false);
}
  };


  return (
    <div className="login-wrapper">
      <div className="login-container container-fluid">
        <div className="row">
          <div className="login-image col-md-6 p-0">
            <img src={loginbg} alt="login" className="w-100 h-100" />
          </div>

          <div className="login-form col-12 col-md-6 d-flex flex-column">
            <div className="login-logo mb-4 text-center">
              <img className="mt-3" src={logo} alt="logo" />

            </div>
             <div >

  <p className="user-login-text mt-2 text-center">
    تسجيل دخول البائع
  </p>
</div>
            <h3 className="mb-3 fw-bold forgot-password">!..مرحبا بعودتك</h3>
{/* 
            {errors.general && (
              <small className="input-error text-center mb-2">
                {errors.general}
              </small>
            )} */}

            <label className="input-label mt-2" placeholder="example@domail.com"
            >
              البريد الالكتروني</label>
            {/* <input
              type="email"
              className="input-field mb-1"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <small className="input-error">{errors.email}</small>} */}
            <div className="input-wrapper">
  <input
    type="email"
    className="input-field "
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    placeholder="example@domain.com"
  />
  {errors.email && (
    <small className="input-error ">{errors.email}</small>
  )}
</div>


            <label className="input-label mt-3 ">كلمة المرور</label>
            <div className="special-password-box">
              <input
                type={showPassword ? "text" : "password"}
                className="login-special-password-input"
                placeholder="كلمة المرور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i
                className={`fa-regular ${
                  showPassword ? "fa-eye" : "fa-eye-slash"
                } special-pass-icon`}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>
            <Link to='/forgetpassword' className="">
                  <span
                className="passlink fw-normal fw-bold "
                onClick={() => navigate("/forgetpassword")}
                style={{ color: "#1d3a77", cursor: "pointer" }}
              >
                هل نسيت كلمة المرور؟
              </span>
              </Link>

            {errors.password && (
              <small className="input-error">{errors.password}</small>
            )}

            {/* <button
              className="login-btn btn w-100 text-white mt-4"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "جاري الدخول..." : "تسجيل دخول"}
            </button> */}
                 <button
  className="login-btn btn w-100 text-white mt-4 mb-3"
  onClick={handleSubmit}
  disabled={loading}
>
  {loading ? "جاري الدخول..." : "تسجيل دخول"}
</button>

{errors.general && (
  <small className="input-error general-error">
    {errors.general}
  </small>
)}
      
         

            <p className="login-account-text mt-3 text-center fw-bold">
              لا تمتلك حساب ؟{" "}
              <span
                className="link fw-normal"
                onClick={() => navigate("/accounttype")}
                style={{ color: "#1d3a77", cursor: "pointer" }}
              >
                إنشاء حساب
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}